import React, { memo, useMemo } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { hasToken } from '../../services/auth';
import { RouteComponentProps, RouteProps } from 'react-router';

const privateComponentFactory = (
  Component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>
): React.FC<RouteComponentProps<any>> => {
  return (renderProps) => {
    if (!hasToken()) {
      return <Redirect to="/login" />;
    }

    return <Component {...renderProps} />;
  };
};

const PrivateRoute = (
  props: RouteProps<any> & {
    component:
      | React.ComponentType<RouteComponentProps<any>>
      | React.ComponentType<any>;
  }
) => {
  const PrivateComponent: React.FC<RouteComponentProps<any>> = useMemo(
    () => privateComponentFactory(props.component),
    [props.component]
  );

  return <Route {...props} component={PrivateComponent} />;
};

PrivateRoute.propTypes = (Route as any).propTypes;

export default memo(PrivateRoute);
